
// import { useState } from "react";
import { Form, Input, Button, Upload, message } from 'antd';
import { Select } from 'antd';
import { Steps } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { TimePicker } from 'antd';
import moment from 'moment';
import { useForm } from "react-hook-form";
import { useState } from 'react';
import { Progress } from 'antd';

import '../../PagesComponent/ProductCompo/ProductRoute/Styles/ManageProduct.scss'
const { Step } = Steps;
const format = 'HH:mm';
const { Option } = Select;

export const StepFormAddProduct = () => {


    //  this is for selected
    const children = [];
    for (let i = 10; i < 36; i++) {
        children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
    } const onFinish = (values) => {
        console.log('Success:', values);
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    const [current, setCurrent] = useState(0);
    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };
    const steps = [
        {
            title: <span className={`manageProductTitles ${current === 0 ? "text-danger" : "text-success"}`}>Basics</span>,
            content: 'Basics',
            icon: <i className={` rounded-pill ${current === 0 ? "IconAct" : current === 1 ? "notIcnAct" : current === 2 ? " notIcnAct" : ""}`}> <span className="fas fa-info px-1"></span></i>
        },
        {
            title: <span className={`manageProductTitles informationTitles ${current === 1 ? "text-danger" : "text-success"}`}>Information</span>,
            content: 'Information',
            icon: <i className={`fas fa-images rounded-pill ${current === 1 ? "IconAct" : current === 0 ? "IconAct" : current === 2 ? " notIcnAct" : ""}`} ></i >

        },
        {
            title: <span className={`manageProductTitles ${current === 2 ? "text-danger" : "text-success"}`}>Controls</span>,
            content: 'Controls',
            icon: <i className={`fas fa-cog  iconStep1 rounded-pill  ${current === 2 ? "IconAct" : current === 0 ? "IconAct" : current === 1 ? " IconAct" : ""}`} ></i >

        },
    ];
    //drag photo
    let [uploadImg, setUploadImg] = useState([])

    const props = {
        name: 'file',
        multiple: true,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange(info) {
            setUploadImg(info.fileList)
            const { status } = info.file;
            if (status === 'done') { message.success(`${info.file.name} file uploaded successfully.`); }
            else if (status === 'error') { message.error(`${info.file.name} file upload failed.`); }
        },
        onDrop(e) { console.log('Dropped files', e.dataTransfer.files) },

    };
    let [uploadImg2, setUploadImg2] = useState([])

    const props2 = {
        name: 'file',
        multiple: true,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange(info) {
            setUploadImg2(info.fileList)
            const { status } = info.file;
            if (status === 'done') { message.success(`${info.file.name} file uploaded successfully.`); }
            else if (status === 'error') { message.error(`${info.file.name} file upload failed.`); }
        },
        onDrop(e) { console.log('Dropped files', e.dataTransfer.files) },

    };



    // select
    let [saveCategory, setCategory] = useState("")
    let [saveFeatured, setFeatured] = useState("")
    let handleCategoryChange = (value) => setCategory(value);
    let handleFeaturedChange = (value) => setFeatured(value);
    let onSearch = (val) => val;
    let [formStatus, setFormStatus] = useState("")
    let handleStatusChange = (value) => setFormStatus(value);
    const handleFormChange = (data) => {
        console.log(formData);
        SetUpdateFormData({ ...formData, [data.target.name]: data.target.value.trim() });

    };

    let handleSave = () => {

    }
    // catchData
    const [formData, SetUpdateFormData] = useState({
        productName: "",
        stock: "",
        unitPrice: "",
        productDescription: "",
        productpolicies: "",
        MOQ: "",
        SKU: "",
        dimensions: "",
        weight: "",
        saleStartDate: "",
        saleEndDate: "",
        salePrice: "",
        bookName: "",
        author: "",
        category: saveCategory,
        featured: saveFeatured,
        publisher: "",
        visibility: "",
        status: formStatus,
        deliveryCharge: "",
        tag: "",

        image: null
    });

    return (
        <Form onFinish={onFinish} onFinishFailed={onFinishFailed} size={'large'}>
            {/*  */}

            <Steps className="manageProduct__step position-relative" current={current} >
                {steps.map(item => (
                    <Step key={item.title} icon={item.icon} title={item.title} />
                ))}
            </Steps>
            <div className="steps-content mt-4  row"  >

                {current === 0 ? <>
                    <div className="col-md-6">
                        <h6>Product Name</h6>
                        <Form.Item name="productName"  >
                            <Input placeholder="ProductName" name="productName" onChange={handleFormChange} />
                        </Form.Item>
                        <small>shown as title</small>

                        <h6>Stock</h6>
                        <Form.Item name="stock" >
                            <Input placeholder="0" type="number" name="stock" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Product stock, if out of stock, product is hidden from the store</small>
                        <h6>Unit Price (৳)</h6>
                        <Form.Item name="unitPrice" >
                            <Input placeholder="0.00 (৳)" type="number" name="unitPrice" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Unit price of the product in BDT</small>
                        <h6>Description</h6>
                        <Form.Item name="productDescription" >
                            <Input.TextArea placeholder="Product Description" type="text" rows={4} name="productDescription" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Product description, shown in the application</small>

                    </div>

                    <div className="col-lg-6">
                        <h6>SKU</h6>
                        <Form.Item name="SKU">
                            <Input placeholder=" SKU Code" type="text" name="SKU" onChange={handleFormChange} />
                        </Form.Item>
                        <small>SKU is a unique name for the product to easily find</small>
                        <h6>Featured</h6>
                        <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Featured"
                            optionFilterProp="children"
                            onChange={handleFeaturedChange}

                            onSearch={onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }  > <Option value="jack">Jack</Option>
                            <Option value="lucy">Lucy</Option>
                            <Option value="tom">Tom</Option>
                        </Select> <br />
                        <small>Featured products are also shown in featured section</small>

                        <h6>Minimum Order Quantity</h6>
                        <Form.Item name="MOQ" >
                            <Input placeholder="0.00 (৳)" type="number" name="MOQ" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Users can not order less than the mentioned quantity</small>

                        <h6>Product Policies</h6>
                        <Form.Item name="productpolicies" >
                            <Input.TextArea placeholder="Product Policies..." name="productpolicies" onChange={handleFormChange} type="text" rows={4} />
                        </Form.Item>
                        <small>Refund, return, delivery and cancellation policies</small>
                    </div>


                </> : current === 1 ? <>
                    <div className="col-lg-6">
                        <h6>Weight (kg)</h6>
                        <Form.Item name="weight" >
                            <Input placeholder="00.00kg" type="text" name="weight" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Weight of the book in kg</small>

                        <h6>Dimensions</h6>
                        <Form.Item name="Dimensions" >
                            <Input placeholder={`0.00" x 0.00" x 0.00"`} type="text" name="dimensions" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Length (inches) x Width (inches) x Height (inches)</small>

                        <h6>Sale Start Date (Optional)</h6>
                        <Form.Item name="saleStartDate" >
                            <input className="form-control " type="date" placeholder="" name="saleStartDate" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Unit price of the product in BDT</small>

                        <h6>Featured Photo</h6>
                        <div>
                            <Upload.Dragger showUploadList={false} {...props} name="files" noStyle={false}>
                                <p className="ant-upload-drag-icon"> </p>
                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                            </Upload.Dragger>
                            <span>The resolution must be 1920X1080 and it must maintain 16:9.
                            </span>
                        </div>
                        {uploadImg?.map((data, index) => <>

                            <div key={index} className="col-lg-6 mt-4 mr-3">
                                <Progress percent={parseInt(data.percent)} />

                            </div>

                        </>)}

                    </div>
                    <div className="col-lg-6">
                        <h6>Category</h6>
                        <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Category"
                            optionFilterProp="children"
                            onChange={handleCategoryChange}

                            onSearch={onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }  > <Option value="jack">Jack</Option>
                            <Option value="lucy">Lucy</Option>
                            <Option value="tom">Tom</Option>
                        </Select> <br />
                        <small> Product will be shown based on the category</small>
                        <h6>Sale Price(৳) (Optional)</h6>
                        <Form.Item name="salePrice" >
                            <Input type="number" placeholder="00.0(৳)" name="salePrice" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Unit price of the product in BDT</small>

                        <h6>Sale  End (Optional)</h6>
                        <Form.Item name="saleEnd" >
                            <input className="form-control " type="date" placeholder="" name="saleEndDate" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Users can not order less than the mentioned quantity</small>
                        <h6>Photo Gallery </h6>
                        <div>
                            <Upload.Dragger showUploadList={false} {...props2} name="files" noStyle={false}>
                                <p className="ant-upload-drag-icon"> </p>
                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                            </Upload.Dragger>
                            <span>The resolution must be 1920X1080 and it must maintain 16:9.
                            </span>
                            {uploadImg2?.map((data, index) => <>

                                <div key={index} className="col-lg-6 mt-4 mr-3">
                                    <Progress percent={parseInt(data.percent)} />

                                </div>

                            </>)}
                        </div>



                    </div>

                </> : <>

                    <div className="col-lg-6">
                        <h6>Book Name</h6>
                        <Form.Item name="bookName" >
                            <Input placeholder="Book Name" type="text" name="bookName" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Name of the book</small>

                        <h6>Author</h6>
                        <Form.Item name="Author" >
                            <Input placeholder="Author Name" type="text" name="author" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Name of the author</small>
                        <h6>Publisher</h6>
                        <Form.Item name="publisher" >
                            <Input placeholder="publisher" type="text" name="publisher" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Name of the publisher</small>
                        <h6>Visibility</h6>
                        <Form.Item name="visibility" >
                            <Input placeholder="Location" type="text" name="visibility" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Product visibility will be shown based on the location</small>
                    </div>
                    <div className="col-lg-6">
                        <h6>Status</h6>
                        <Select defaultValue="" placeholder="Select Category" style={{ width: 120 }} onChange={handleStatusChange}>
                            <Option value="published">published</Option>
                            <Option value="darft">draft</Option>
                            <Option value="private"> private</Option>
                        </Select> <br />
                        <small> Product can be set to private, published and draft status</small>
                        <h6>Delivery Charge(৳)</h6>
                        <Form.Item name="0.00 (৳)" >
                            <Input placeholder="Delivery Charge" type="text" name="deliveryCharge" onChange={handleFormChange} />
                        </Form.Item>
                        <small>Set the delivery charge for the minimum order quantity in BDT.</small>
                        <h6>Delivery Time</h6>
                        <TimePicker defaultValue={moment('12:08', format)} format={format} /> <br />
                        <small>Select the delivery time required</small>
                        <h6>Tags</h6>
                        <Form.Item name="tags" >
                            <Input placeholder="Tags" type="text" name="tags" onChange={handleFormChange} />
                        </Form.Item>

                        <small>Tags are useful for searching. Use comma (,) to separate the tags</small>
                    </div>
                </>}
            </div>
            <div className="mangeProduct__steps-action">
                {current > 0 && (
                    <button className="btn btn-outline-secondary px-4 mx-2" onClick={() => prev()}>
                        Back
                    </button>
                )}
                <button style={{ margin: '0 8px' }} className="btn btn-outline-danger px-4 ml-5" onClick={handleSave}>Save</button>

                {current < steps.length - 1 && (
                    <button className="btn btn-success ml-5 px-4 mx-2" onClick={() => next()}>
                        Next
                    </button>
                )}
                {current === steps.length - 1 && (
                    <button className="btn btn-success px-4 mx-2"  >
                        Publish
                    </button>
                )}
            </div>
            <Form.Item>
                <Button type="primary" htmlType="submit">
                    Submit
                </Button>
            </Form.Item>
        </Form>
    )

}


export const StepFormEditDetails = ({ current, which, singleData }) => {

    // disabled={which ? true : false} defaultValue={singleData?.name}
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data) => {

    }
    const format = 'HH:mm';
    const normFile = (e) => {
        console.log('Upload event:', e);
        if (Array.isArray(e)) {
            return e;
        } return e && e.fileList;
    };


    //  this is for selected
    const children = [];
    for (let i = 10; i < 36; i++) {
        children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
    }

    function handleChange(value) {
        console.log(`selected ${value}`);
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="row">
                    {current === 0 ? <>
                        <div className="co-lg-6 col-md-6 col-sm-12">
                            <h6>Product  Name</h6>
                            <input className=" form-control " placeholder="" {...register("productName", { required: false })} />
                            <small className="mb-2 text-muted"> Shown as title</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}



                            <h6>Stock</h6>
                            <input className=" form-control " placeholder="0" {...register("stock", { required: false })} />
                            <small className="mb-2 text-muted"> Product stock, if out of stock, product is hidden from the store</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}



                            <h6>Unit Price (৳)</h6>
                            <input className=" form-control " placeholder=""  {...register("unitPrice", { required: false })} />
                            <small className="mb-2 text-muted">Unit price of the product in BDT</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                            <h6>Description</h6>
                            <textarea rows="5" cols="" className=" form-control " placeholder=""  {...register("description", { required: false })} />
                            <small className="mb-2 text-muted"> Product description, shown in the application</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}
                        </div>

                        <div className="col-lg-6  col-md-6 col-sm-12">

                            <h6>SKU</h6>
                            <input className=" form-control " placeholder="SKU code"  {...register("SKU", { required: false })} />
                            <small className="mb-2 text-muted"> SKU is a unique name for the product to easily find</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}



                            <h6>Featured</h6>
                            <Form.Item rules={[{ required: false, message: 'This field is required!', },]} >
                                <Select mode="tags" style={{ width: '100%' }} placeholder="Tags Mode" onChange={handleChange}>
                                    {children}
                                </Select>
                                < small>Featured products are also shown in featured section</small>

                            </Form.Item>

                            <h6>Minimum Order Quantity</h6>
                            <input className=" form-control " placeholder=""  {...register("000", { required: false })} />
                            <small className="mb-2 text-muted">Users can not order less than the mentioned quantity</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}


                            <h6>Product Polices</h6>
                            <textarea rows="5" cols="" className=" form-control " placeholder=""  {...register("productPolicies", { required: false })} />
                            <small className="mb-2 text-muted"> Refund, return, delivery and cancellation policies</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                        </div>


                    </> : current === 1 ? <>

                        <div className="co-lg-6  col-md-6 col-sm-12">
                            <h6>Weight(kg)</h6>
                            <input className=" form-control " placeholder="00.0kg"  {...register("weight", { required: false })} />
                            <small className="mb-2 text-muted"> Weight of the book in kg</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                            <h6>Dimension</h6>
                            <input className=" form-control " placeholder="0.00 x 0.00 x 0.00"  {...register("dimension", { required: false })} />
                            <small className="mb-2 text-muted"> Length (inches) x Width (inches) x Height (inches)</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                            <h6>Sale Start Date(Optional)</h6>
                            <input className=" form-control " type="date"  {...register("saleStartDate", { required: false })} />
                            <small className="mb-2 text-muted">Unit price of the product in BDT</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                            <h6>Featured Photo</h6>
                            <Form.Item valuePropName="fileList" getValueFromEvent={normFile} s>
                                <Upload.Dragger name="files" action="/upload.do">
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">Click or drag file to this area to upload</p>

                                </Upload.Dragger>
                                <small>The resolution must be 1920X1080 and it must maintain 16:9</small>
                            </Form.Item>

                        </div>
                        <div className="col-lg-6  col-md-6 col-sm-12">
                            <h6>Category</h6>

                            <Select mode="tags" style={{ width: '100%' }} placeholder="Select Category" onChange={handleChange}>
                                {children}
                            </Select>
                            <small>Product will be shown based on the category</small>

                            <h6> Sale Price </h6>
                            <input className=" form-control " placeholder=""  {...register("salePrice", { required: false })} />
                            <small className="mb-2 text-muted"> Sale price will reduce the price</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                            <h6>Sale End Date(Optional)</h6>
                            <input className=" form-control " type="date"   {...register("saleEndDate", { required: false })} />
                            <small className="mb-2 text-muted">Users can not order less than the mentioned quantity</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}


                            <h6> Photo Gallery</h6>
                            <Form.Item valuePropName="fileList" getValueFromEvent={normFile} s>
                                <Upload.Dragger name="files" action="/upload.do">
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">Click or drag file to this area to upload</p>

                                </Upload.Dragger>
                                <small>The resolution must be 1920X1080 and it must maintain 16:9</small>
                            </Form.Item>

                        </div>

                    </> : <>
                        <div className="col-lg-6  col-md-6 col-sm-12">
                            <h6>Book Name</h6>
                            <input className=" form-control " placeholder=""  {...register("bookName", { required: false })} />
                            <small className="mb-2 text-muted">Book Name</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                            <h6>Author </h6>
                            <input className=" form-control " placeholder=""  {...register("author", { required: false })} />
                            <small className="mb-2 text-muted">Name of the author</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                            <h6> Publisher</h6>
                            <input className=" form-control " placeholder=""  {...register("publisher", { required: false })} />
                            <small className="mb-2 text-muted"> Name of the publisher</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                            <h6>Visibility </h6>
                            <input className=" form-control " placeholder=""  {...register("visibility", { required: false })} />
                            <small className="mb-2 text-muted"> Product visibility will be shown based on the location</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                        </div>
                        <div className="col-lg-6  col-md-6 col-sm-12">
                            <h6>Status</h6>
                            <select className="form-select" aria-label="Default select example">
                                <option selected>Slect Status</option>
                                <option value="private">Private</option>
                                <option value="draft">draft</option>
                                <option value="published">published</option>
                            </select>
                            <small className="mb-2 text-muted">Product can be set to private, published and draft status</small><br />


                            <h6>Delivery Charge  (৳) </h6>
                            <input className=" form-control " placeholder=""  {...register("deliveryCharge", { required: false })} />
                            <small className="mb-2 text-muted"> delivery charge for the minimum order quantity in BDT.</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}

                            <h6>Delivery Time</h6>
                            <Form.Item rules={[{ required: false, message: 'This field is required!', },]} >
                                <TimePicker defaultValue={moment('12:08', format)} format={format} /> <br />
                                <small>Select the delivery time required</small>
                            </Form.Item>


                            <h6>Tags </h6>
                            <input className=" form-control " placeholder=""  {...register("tags", { required: false })} />
                            <small className="mb-2 text-muted">Tags are useful for searching. Use comma (,) to separate the tags</small><br />
                            {errors.name && <span className="text-danger">This field is required</span>}
                        </div> </>}  </div>

                <input type="submit" value="Publish" />
            </form>
        </>
    )






}

